import styled from 'styled-components'
import { Form } from 'formik'
import { colors } from '../../styles'

export const StyledAllTypesTable = styled.table`
  min-width: 75%;
  max-width: 100%;
  tr {
    padding: 8px 8px;
    display: grid;
    grid-template-columns: 0.5fr 2fr 1fr 1fr 2fr;
  }
  td,
  th {
    word-break: break-all;
    text-align: left;
  }
  tbody tr {
    cursor: pointer;
    &:hover {
      background-color: ${colors.orange10};
    }
  }
  td {
    display: flex;
    align-items: center;
  }
`

export const StyledForm = styled(Form)`
  height: 100%;

  aside {
    h2,
    button {
      margin-bottom: 16px;
    }
    p {
      margin-bottom: 24px;
    }
  }
`
